import store from '@/store'
import axios from 'axios'

store.subscribe((mutation) => {
    switch(mutation.type) {
        case 'UserStore/SET_B2C_AUTH_DATA' :
            if(mutation.payload) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload.accessToken}`

                const store = {
                    username: mutation.payload.account.name,
                    authData: mutation.payload.account
                }

                localStorage.setItem('auth_data', JSON.stringify(store))                
            } else {
                axios.defaults.headers.common['Authorization'] = null
                localStorage.removeItem('auth_data')
            }
        break

        case 'UserStore/REMOVE_AUTH_DATA' :
            axios.defaults.headers.common['Authorization'] = null
            localStorage.removeItem('auth_data')
        break
    }
})